import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { apiUrls } from '../../constants/apiUrl';

export const swithToFRP = (data) => ({
  type: 'SWITCH_TO_FRP',
  data,
});

export const swithToFRPApi = () => {
  const postData = {
    serviceHeader: {
      statusMsg: 'PEGA generated message',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    serviceBody: {
      serviceRequest: {
        context: {
          customerInfo: {
            processingMTN: '',
            originalCreditApprovalNumber: '',
            customerType: 'N',
          },
          cartInfo: {
            itemType: 'SWITCHTOFRP',
            intendType: 'NSE',
            action: 'UPDATE',
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: 'NSE',
            processStep: 'EligibilityReview',
            processAction: 'updateFRP',
          },
        },
      },
    },
  };
  return HttpService.post(`${getSecureBaseUrl()}${apiUrls().swithToFRPUrl}`, postData);
};

export const creditInEligibleClicked = (data) => ({
  type: 'CREDIT_INELIGIBLE_CLICKED',
  data,
});

export const getCartDetails = () => {
  let postData = { meta: {}, data: {} };
  postData = { meta: {}, data: { validateCart: false } };
  return HttpService.post(`${getSecureBaseUrl()}${apiUrls().getCartDetailsurl}`, postData);
};
